import { useEffect } from "react";
import { Loader2 } from "lucide-react";

// Microsoft redirects to the root-domain /auth/microsoft/callback (no /api prefix),
// which lands on this SPA. We do nothing with the code except hand it straight to
// the backend callback (same origin, /api → backend) so it can set the auth cookie.
export default function MicrosoftCallback() {
    useEffect(() => {
        window.location.replace(`${window.location.origin}/api/auth/microsoft/callback${window.location.search}`);
    }, []);

    return (
        <div className="min-h-screen grid place-items-center bg-[#F5F3F0]" data-testid="ms-callback-page">
            <div className="flex items-center gap-3 text-[#6F6A64]">
                <Loader2 className="w-5 h-5 animate-spin" style={{ color: "#C75A1B" }} />
                <span className="font-serif-italic text-lg">Completing Microsoft sign-in…</span>
            </div>
        </div>
    );
}
